import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const CreateFavourite = {
  name: 'createFavourite',
  state: {
    data: {},
    loading: false,
    error: '',
    success: '',
  },
  reducers: {
    createRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        success: '',
      };
    },

    createSucceeded(state, payload) {
      return {
        ...state,
        data: payload,
        loading: false,
        error: '',
        success: 'Advertiser Favourited successfully.',
      };
    },

    createFailed(state, payload) {
      return {
        ...state,
        error: payload,
        loading: false,
        success: '',
      };
    },

    clearMessages(state) {
      return {
        ...state,
        error: '',
        success: '',
      };
    },
  },
  effects: (dispatch) => ({
    async createNewFavourite({ org_id,createdByUser }) {
      try {
        const payload = {
          org_id,
          createdByUser
        };

        this.createRequested();

        const response = await http.post('savvy/favourite', payload);
        this.createSucceeded(response.data);

        dispatch({
          type: 'helper/show',
          payload: {
            type: 'success',
            message: 'Advertiser Favourited successfully.',
            show: true,
          },
        });
      } catch (error) {
        const errorMessage = responseMessageHandler.show(error.message);
        this.createFailed(errorMessage);

        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: errorMessage,
            show: true,
          },
        });
      }
    },

    async clearStateMessages() {
      this.clearMessages();
    },
  }),
};

export default CreateFavourite;

